import { render } from "./NFooter.vue?vue&type=template&id=f7bdf3dc"
import script from "./NFooter.vue?vue&type=script&lang=js"
export * from "./NFooter.vue?vue&type=script&lang=js"

import "./NFooter.vue?vue&type=style&index=0&id=f7bdf3dc&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__